/* src/app/_shared/components/appointment-edit-comments/appointment-edit-comments.modal.scss */
main {
  padding: var(--space);
}
/*# sourceMappingURL=appointment-edit-comments.modal.css.map */
